import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { message } from "antd";
import drEasyApi from "../Api/Customapi";

export const OVR_QUERY_KEY = ["ovr"];
export const OVR_LIST_QUERY_KEY = ["ovr-list"];
export const STAFF_QUERY_KEY = ["staff"];

export const useGetOvr = (ovrId) => {
  return useQuery({
    queryKey: [...OVR_QUERY_KEY, ovrId],
    queryFn: async () => {
      const res = await drEasyApi.get("/api/Ovr/Get", {
        params: { OvrId: ovrId },
      });
      return res.data;
    },
    enabled: !!ovrId,
    onError: (error) => {
      message.error(error?.response?.data?.[0] || "Failed to fetch OVR");
    },
  });
};

export const useGetAllOvrs = (params = {}) => {
  return useQuery({
    queryKey: [...OVR_LIST_QUERY_KEY, params],
    queryFn: async () => {
      const res = await drEasyApi.get("/api/Ovr/GetAll", {
        params: {
          pageNumber: params.pageNumber || 1,
          pageSize: params.pageSize || 10,
        },
      });
      return res.data || { ovrs: [], totalCount: 0, pageNumber: 1, pageSize: 10 };
    },
    onError: (error) => {
      message.error(error?.response?.data?.[0] || "Failed to fetch OVRs");
    },
  });
};

export const useGetStaff = (params = {}) => {
  return useQuery({
    queryKey: [...STAFF_QUERY_KEY, params],
    queryFn: async () => {
      const res = await drEasyApi.get("/api/Centers/GetStaff", {
        params: {
          PageNumber: params.pageNumber || 1,
          PageSize: params.pageSize || 100,
          Role: params.role,
        },
      });
      return res.data || { staff: [], totalCount: 0 };
    },
    onError: (error) => {
      message.error(error?.response?.data?.[0] || "Failed to fetch staff");
    },
  });
};

export const useCreateOvr = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (ovrData) => {
      return await drEasyApi.post("/api/Ovr/Create", ovrData);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(OVR_LIST_QUERY_KEY);
      message.success("OVR created successfully");
    },
    onError: (err) => {
      const errorMessage = err?.response?.data?.[0] || "Failed to create OVR";
      message.error(errorMessage);
    },
  });
};

// Respond to OVR mutation
export const useRespondToOvr = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (responseData) => {
      return await drEasyApi.post("/api/Ovr/Respond", responseData);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(OVR_QUERY_KEY);
      queryClient.invalidateQueries(OVR_LIST_QUERY_KEY);
      message.success("Response added successfully");
    },
    onError: (err) => {
      const errorMessage = err?.response?.data?.[0] || "Failed to add response";
      message.error(errorMessage);
    },
  });
};

// Close OVR mutation
export const useCloseOvr = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (ovrId) => {
      return await drEasyApi.post("/api/Ovr/Close", { ovrId });
    },
    onSuccess: () => {
      queryClient.invalidateQueries(OVR_QUERY_KEY);
      queryClient.invalidateQueries(OVR_LIST_QUERY_KEY);
      message.success("OVR closed successfully");
    },
    onError: (err) => {
      const errorMessage = err?.response?.data?.[0] || "Failed to close OVR";
      message.error(errorMessage);
    },
  });
};

// Move OVR mutation
export const useMoveOvr = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (moveData) => {
      return await drEasyApi.post("/api/Ovr/Move", moveData);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(OVR_QUERY_KEY);
      queryClient.invalidateQueries(OVR_LIST_QUERY_KEY);
      // message.success("OVR moved successfully");
    },
    onError: (err) => {
      const errorMessage = err?.response?.data?.[0] || "Failed to move OVR";
      message.error(errorMessage);
    },
  });
};